import { useState } from "react";
import styles from '../Settings/AppVersion.module.css'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import VenueUpdateLeagueAndTeams from "./VenueUpdateLeagueAndTeams";
import PickVenues from "../AddTickets/PickVenues";

const VenueUpdate = () => {
    const [page, setPage] = useState(0);
    const [ticketDetails, setTicketDetails] = useState(null);
    const [resetEvent, setResetEvent] = useState(false)
    const [search, setSearch] = useState(false);

  return (
        <div className={styles.maindiv}>
            
            <div className={styles.seconddiv} style = { {width: '90%', gap: '0px'}}>
                <VenueUpdateLeagueAndTeams setSearch= {setSearch} setPage = {setPage} setTicketDetails = {setTicketDetails} ticketDetails = {ticketDetails} page = {page} resetEvent={resetEvent} setResetEvent = {setResetEvent} />
                <PickVenues setPage = {setPage} setTicketDetails = {setTicketDetails} ticketDetails = {ticketDetails} page = {page} isFrom={'venuesUpdate'} resetEvent={resetEvent} setResetEvent = {setResetEvent} search = {search}/>
            </div>
        </div>
  )
}

export default VenueUpdate